<!--
  --
  -- パスワード設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-password-group
      @confirmed="onConfirmed"
    >
      <!-- タイトル -->
      <template #title>パスワードを変更</template>

      <!-- 説明文 -->
      <template>
        <p>
          ログインパスワードを変更します。<br>
          新しいパスワードを入力して下さい。
        </p>
      </template>

      <template #submit-text>パスワードを設定</template>
    </c-password-group>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CPasswordGroup from '@/pages/register/Password/CPasswordGroup'

import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'Password',
  mixins: [
    page('パスワードを変更')
  ],
  components: {
    CPasswordGroup
  },

  /**
   * データ取得
   */
  prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']
    if (!userID) {
      throw new Error('The user is not logged in.')
    }
    return { userID }
  },

  props: {
    userID: Number
  },

  methods: {
    /**
     * パスワードが確認された
     */
    onConfirmed (password) {
      run(async () => {
        await api.putUserPassword(this.userID, {
          account: {
            password
          }
        })

        this.back()
      })
    }
  }
}
</script>
